import {ResourceData} from "../common/resource/resource-service";
import {IDiscount} from "./discount-models";

export class DiscountData extends ResourceData<IDiscount> {
    constructor() {
        super("/v5/discount");
    }
}
